import { useCallback } from 'react';
import { DateRangeEnd } from '../enums';
import { endOfMonth, startOfMonth } from 'date-fns';
import { IDateState } from '../types';

/**
 * Returns a function that sets the date to the start or end of the month.
 */
export const useMonthSelectorSetter = ({
  dateRangeEnd,
  setDate,
}: { dateRangeEnd: DateRangeEnd } & Pick<IDateState, 'setDate'>) =>
  useCallback(
    (value: Date | undefined) => {
      if (!value) {
        setDate(undefined);
        return;
      }
      switch (dateRangeEnd) {
        case DateRangeEnd.start: {
          const clean = startOfMonth(value);
          setDate(clean);
          break;
        }
        case DateRangeEnd.end: {
          const clean = endOfMonth(value);
          setDate(clean);
          break;
        }
        default:
          setDate(value);
      }
    },
    [dateRangeEnd, setDate]
  );
